<script setup>
/**
 * Verkoop-header. Bootstrap (logo, teksten) komt uit header-vue-mount.tpl.
 * Zelfde opbouw als Verhuur; alleen de blauwe actiebalk heeft een eigen tint.
 */
import VerhuurHeader from '@verhuur/header/SiteHeader.vue';
</script>

<template>
  <div class="vsb-verkoop-header">
    <VerhuurHeader />
  </div>
</template>

<style scoped>
/* Verkoop-merkblauw (#004494) i.p.v. Verhuur-navy (#0b3d91) */
.vsb-verkoop-header :deep(.vsb-header__action) {
  background: #004494;
}
.vsb-verkoop-header :deep(.vsb-header__categories:hover),
.vsb-verkoop-header :deep(.vsb-header__categories--active) {
  background: #1560c4;
}
</style>
